import { Menu, MenuItem } from "@blueprintjs/core";
import React from "react";

import styles from "./play-property-context-menu.module.scss";

export interface PlayPropertyContextMenuProps {
  playProperty: string;
  onEdit: () => void;
  onDelete: () => void;
}

export const PlayPropertyContextMenu = ({ playProperty, onEdit, onDelete }: PlayPropertyContextMenuProps) => {
  return (
    <Menu className={styles.contextMenu}>
      <MenuItem text={`Edit ${playProperty}`} onClick={onEdit} icon="edit" />
      <MenuItem text={`Delete ${playProperty}`} onClick={onDelete} icon="trash" />
    </Menu>
  );
};
